import script from "./PostFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostFormView.vue?vue&type=script&setup=true&lang=js"

import "./PostFormView.vue?vue&type=style&index=0&id=286f3f16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-286f3f16"]])

export default __exports__